import { FormControlLabel, Switch } from '@ds/coolshop';
import { ControlFieldProps } from '@src/assets/types';
import { useController } from 'react-hook-form';

function ControlFieldElement({
    name,
    label,
    control,
    isDisabled = false,
    checkedField,
    onChange,
}: ControlFieldProps) {
    const { field } = useController({
        name,
        control,
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        field.onChange(event); // Chiamata al metodo onChange di react-hook-form
        if (onChange) {
            onChange(event, checked); // Chiamata all'onChange personalizzato, se definito
        }
    };

    return (
        <FormControlLabel
            label={label}
            control={
                <Switch
                    checked={checkedField || field.value}
                    value={checkedField || field.value}
                    disabled={isDisabled || field.disabled}
                    onChange={handleChange}
                />
            }
        />
    );
}

export default ControlFieldElement;
